<template>
  <savvy id="flow_90iaf85f71dh8fe5j531jf3a8"></savvy>
</template>

<script>
export default {
  name: 'EmbeddablesForm',
  computed: {
    
  },
  mounted() {
    try {
      if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('isFromEmbeddables', JSON.stringify({
          value: true,
          timestamp: Date.now()
        }))
      }
    } catch (e) {
      console.log('sessionStorage not available')
    }
    if (window.initEmbeddables) {
      window.initEmbeddables()
    }
  }
}
</script>
